var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-bold table-title",class:{
    'is-full-width': _vm.isFullWidth,
    'is-centered': _vm.isCentered
  },style:(`height:${_vm.height}px`)},[_c('div',{staticClass:"title-content"},[_vm._v(" "+_vm._s(_vm.tableTitle)+" ")]),_vm._t("buttons")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }